import DataSourceTypeIcon from './data-source-type-icon';

export default DataSourceTypeIcon;